import { render } from "./ContentHeader.vue?vue&type=template&id=c87075e8&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=c87075e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87075e8"],['__file',"src/components/budget/ContentHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c87075e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c87075e8', __exports__)) {
    api.reload('c87075e8', __exports__)
  }
  
  module.hot.accept("./ContentHeader.vue?vue&type=template&id=c87075e8&scoped=true", () => {
    api.rerender('c87075e8', render)
  })

}


export default __exports__